import { render, staticRenderFns } from "./ExtractOfferDetails.vue?vue&type=template&id=6804adee&scoped=true&"
import script from "./ExtractOfferDetails.vue?vue&type=script&lang=js&"
export * from "./ExtractOfferDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExtractOfferDetails.vue?vue&type=style&index=0&id=6804adee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804adee",
  null
  
)

export default component.exports